export const maintenanceMessages = {
  en: {
    title: 'We’ll be back soon!',
    text: (
      <div>
        Sorry for the inconvenience but we’re performing some maintenance at the
        moment. If you need to, you can always{' '}
        <a href='mailto: support@ipfabric.io'>contact us</a>, otherwise we’ll be
        back online shortly!
      </div>
    ),
    btnRefresh: 'Refresh',
  },
};
